import { useAct } from 'DashboardBuilder/store'
import FieldMap from '../../../../FieldMap'
import '../styles/Editors.scoped.scss';

export default function EditorField({field, onChange}) {
  const act = useAct()

  const selectedField = FieldMap.find((mapField) => mapField.source === field.source)
  const Editor = selectedField ? withEditorArgs(selectedField.editorComponent, field, onChange) : null

  return <div className="source-field-editor">
        {Editor && <Editor/>}
    </div>
}

function withEditorArgs(WrappedEditor, field, onChange) {
  return class FieldEditor extends React.Component {
    render() {
      return <WrappedEditor field={field} onChange={onChange} {...this.props} />;
    }
  };
}
